import { AsyncPipe, CommonModule, NgTemplateOutlet } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { DeviceService } from '@shared/services';
import { ModalCloseStrategy, SdModalOptions } from '@shared/v2/models';
import { map, Observable, take } from 'rxjs';
import { SdModal } from './modal';
import { SD_MODAL_OPTIONS_TOKEN } from './modal-options.token';
import { SdvorModalCompactComponent, SdvorModalFullscreenComponent, SdvorModalStandardComponent } from './modal-types';

@Component({
  selector: 'sd-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    SdvorModalCompactComponent,
    SdvorModalStandardComponent,
    SdvorModalFullscreenComponent,
    NgTemplateOutlet,
    CommonModule,
  ],
})
export class SdvorModalComponent implements AfterContentInit {
  options$: Observable<SdModalOptions>;

  constructor(
    private modal: SdModal,
    @Inject(SD_MODAL_OPTIONS_TOKEN) private options: SdModalOptions,
    private deviceService: DeviceService,
  ) {}

  @HostListener('document:keydown.escape')
  onEscapeKeydown(): void {
    this.closeModal();
  }

  onBackdropClick(): void {
    this.options$.pipe(take(1)).subscribe((options) => {
      if (options.closeStrategy !== ModalCloseStrategy.Backdrop || options.ignoreOutsideClick) {
        return;
      }
      this.closeModal();
    });
  }

  ngAfterContentInit(): void {
    this.options$ = this.getOptionsForCurrentBreakpoint();
  }

  closeModal(): void {
    this.modal.close();
  }

  getOptionsForCurrentBreakpoint(): Observable<SdModalOptions> {
    return this.deviceService.breakpoint$.pipe(
      map((breakpoint) =>
        Object.entries(this.options).reduce((acc: any, [key, value]) => {
          acc[key] = value[breakpoint];

          return acc;
        }, {} as SdModalOptions),
      ),
    );
  }
}
